// extracted by mini-css-extract-plugin
module.exports = {"age-verification-text":"age-verification_age-verification-text__ueaSQ"};